import React from 'react';
import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import { Captions, Fullscreen, Thumbnails, Zoom } from 'yet-another-react-lightbox/plugins';
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import Images from './images.tsx';
import './images.css'

function Gallery({ data }: { data: any[] }) {

    const [index, setIndex] = useState<number>(-1);

    return (
        <>
            <Images
                data={data}
                onClick={(currentIndex) => { setIndex(currentIndex) }}>
            </Images>

            <Lightbox
                plugins={[Captions, Fullscreen, Zoom, Thumbnails]}
                captions={{ showToggle: true, descriptionTextAlign: 'end' }}
                index={index}
                open={index >= 0}
                close={() => setIndex(-1)}
                slides={data}
            />
        </>
    );
}

export default Gallery;